module.exports = __webpack_public_path__ + "static/img/VA@3x.af54df2e.png";